import * as types from '../mutation-types'
import versionCheck from '@/libs/version-check'
import users from '@/api/users'

const state = {
  notifications: [],
  unreadNotificationsCount: 0
}

const getters = {
  notifications: (state) => {
    return state.notifications
  },
  unreadNotificationsCount: (state) => {
    return state.unreadNotificationsCount
  }
}

const actions = {
  addNotification ({ commit }, { key, message, title, deepLink }) {
    commit(types.ADD_NOTIFICATION, { key, message, title, deepLink })
  },
  addErrorNotification ({ commit }, message) {
    commit(types.ADD_NOTIFICATION, { message, key: 'error', error: true })
  },
  deleteNotification ({ commit }, key) {
    commit(types.DELETE_NOTIFICATION, key)
  },
  decrementNotificationCount ({ commit }, count) {
    commit(types.DECR_UNREAD_NOTIFICATIONS_COUNT, count)
  },
  resetNotificationCount ({ commit }) {
    commit(types.RESET_UNREAD_NOTIFICATIONS_COUNT)
  },
  getUnreadNotifications ({ commit }, { username }) {
    return new Promise((resolve, reject) => {
      users.getUnreadNotificationsCount(username).then((response) => {
        const count = response.data.result.count
        commit(types.SET_UNREAD_NOTIFICATIONS_COUNT, count)
        resolve({ count })
      }, (error) => {
        reject(error)
      })
    })
  },
  socketMessage ({ dispatch, commit }, message) {
    const payload = message.payload || {}

    if (payload.action === 'update' && payload.type === 'version') {
      versionCheck.check()
    }

    if (payload.action === 'new') {
      commit(types.INCR_UNREAD_NOTIFICATIONS_COUNT, 1)
    }
  }
}

const mutations = {
  [types.INCR_UNREAD_NOTIFICATIONS_COUNT] (state, count) {
    state.unreadNotificationsCount = state.unreadNotificationsCount + count
  },
  [types.DECR_UNREAD_NOTIFICATIONS_COUNT] (state, count) {
    state.unreadNotificationsCount = state.unreadNotificationsCount - count
  },
  [types.RESET_UNREAD_NOTIFICATIONS_COUNT] (state) {
    state.unreadNotificationsCount = 0
  },
  [types.SET_UNREAD_NOTIFICATIONS_COUNT] (state, count) {
    state.unreadNotificationsCount = count
  },
  [types.ADD_NOTIFICATION] (state, notification) {
    const index = findNotification(state, notification.key)
    if (index === -1) {
      state.notifications.push(notification)
    }
  },
  [types.DELETE_NOTIFICATION] (state, key) {
    const index = findNotification(state, key)
    if (index >= 0) {
      state.notifications.splice(index, 1)
    }
  }
}

const findNotification = function (state, key) {
  let index = -1
  for (let i = 0; i < state.notifications.length; i++) {
    if (key === state.notifications[i].key) {
      index = i
      break
    }
  }

  return index
}
export default {
  state,
  getters,
  actions,
  mutations
}
